import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const hasAccepted = localStorage.getItem('cookiesAccepted');
    if (!hasAccepted) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 p-4 bg-white border-t border-gray-200 shadow-lg">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-gray-600 text-sm text-center sm:text-left">
          We use cookies to improve site performance.{' '}
          <a 
            href="/cookie-policy" 
            target="_blank" 
            rel="noopener noreferrer"
            className="text-[#1a1f4e] underline hover:no-underline"
          >
            Learn more
          </a>
        </p>
        <div className="flex gap-3">
          <Button
            onClick={handleAccept}
            className="bg-[#00c853] hover:bg-[#00a844] text-white px-6 py-2 text-sm font-medium rounded-lg"
          >
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
